import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import ReinforcementBody from "./ReinforcementBody";
function Reinforcement() {
  const [filteredData, setFilteredData] = useState([]);
  const [error, setError] = useState(null);
  const [key, setKey] = useState(0); // Use a state to track changes in itemData
  const [showBotDetails, setShowBotDetails] = useState(false);
  const [showTopDetails, setShowTopDetails] = useState(false);
  const [itemData, setItemData] = useState(null);
  const navigate = useNavigate();
  const { partLot_LotNum, company } = useParams();

  useEffect(() => {
    const sliderPanel = document.querySelector(".slider-panel-Reinforcement");
    if (sliderPanel) {
      sliderPanel.style.display = "none"; // Set display to none on page load
    }
  }, []);
  useEffect(() => {
    if (itemData) {
      setKey((prevKey) => prevKey + 1); // Increment key to trigger a re-render
    }
  }, [itemData]);
  const handleBack = () => {
    navigate(-1); // This takes the user to the previous page in the history stack
  };
  const toggleBotForm = () => {
    setShowBotDetails(!showBotDetails);
  };
  const fetchElment = async () => {
    openSliderPanel();
    try {
      const username = process.env.REACT_APP_USER;
      const password = process.env.REACT_APP_PASSWORD;
      const token = btoa(`${username}:${password}`);

      const response = await fetch(
        `${process.env.REACT_APP_DEV_URI}/v1/BaqSvc/IIT_SmartPlannerItemsV2(${company})/`,
        {
          headers: {
            // 'X-API-Key': 'VfiXHKUKRBW2tyWyC7FLnwEPnYKoRW0x76RWvMeSBzLmD',
            Authorization: `Basic ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Error fetching customers: ${response.statusText}`);
      }

      const data = await response.json();

      // Filter data to only include items where partLot_LotNum is "212171"
      const filteredData = data.value.filter((item) => item.PartLot_LotNum === partLot_LotNum);

      // Set the filtered data
      setFilteredData(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const UpdateElementData = async () => {
    if (filteredData.length > 0) {
      const itemToUpdate = { ...filteredData[0] }; // Clone the first matching item

      // Update the fields from botReinforcement and topReinforcement
      const updatedItemData = {
        ...itemToUpdate,
        PartLot_BOTLong_c: botReinforcement.LLong,
        PartLot_BOTECROS_c: botReinforcement.ECross,
        PartLot_BOTDCROS_c: botReinforcement.DCross,
        PartLot_TOPLong_c: topReinforcement.LLong,
        PartLot_TOPECROS_c: topReinforcement.ECross,
        PartLot_TOPDCROS_c: topReinforcement.DCross,
      };

      const body = {
        PartLot_Company: itemToUpdate.PartLot_Company,
        PartLot_BuildingType_c: itemToUpdate.PartLot_BuildingType_c,
        PartLot_LotNum: itemToUpdate.PartLot_LotNum,
        PartLot_PartNum: itemToUpdate.PartLot_PartNum,
        PartLot_Length_c: itemToUpdate.PartLot_Length_c,
        PartLot_Width_c: itemToUpdate.PartLot_Width_c,
        PartLot_Depth_c: itemToUpdate.PartLot_Depth_c,
        PartLot_Count_c: itemToUpdate.PartLot_Count_c,
        PartLot_Project_c: itemToUpdate.PartLot_Project_c,
        PartLot_WBS_c: itemToUpdate.PartLot_WBS_c,
        PartLot_ElementStatus_c: itemToUpdate.PartLot_ElementStatus_c,
        PartLot_BOTLong_c: botReinforcement.LLong,
        PartLot_BOTECROS_c: botReinforcement.ECross,
        PartLot_BOTDCROS_c: botReinforcement.DCross,
        PartLot_TOPLong_c: topReinforcement.LLong,
        PartLot_TOPECROS_c: topReinforcement.ECross,
        PartLot_TOPDCROS_c: topReinforcement.DCross,
        PartLot_MoldID_c: itemToUpdate.PartLot_MoldID_c,
        PartLot_Volume2_c: itemToUpdate.PartLot_Volume2_c,
      };

      try {
        const username = process.env.REACT_APP_USER;
        const password = process.env.REACT_APP_PASSWORD;
        const token = btoa(`${username}:${password}`);

        const postResponse = await fetch(
          `${process.env.REACT_APP_DEV_URI}/v1/BaqSvc/IIT_SmartPlannerItemsV1(${company})/`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          },
        );

        if (!postResponse.ok) {
          throw new Error(`Error posting data: ${postResponse.statusText}`);
        }

        const updatedItem = await postResponse.json();

        // Immediately update the state to reflect changes
        setItemData(updatedItemData);
        setFilteredData([updatedItemData]); // Update filteredData to keep it in sync
        console.log("Updated data:", updatedItem);
        closeSliderPanel(); // Close the slider panel
      } catch (error) {
        console.error("Error updating element data:", error);
      }
    } else {
      console.log("No matching data found to update.");
    }
  };

  const openSliderPanel = () => {
    const sliderPanel = document.querySelector(".slider-panel-Reinforcement");
    if (!sliderPanel) {
      console.error("Slider panel element not found.");
      return;
    }

    // Show the slider panel
    sliderPanel.style.display = "block";
  };
  const closeSliderPanel = () => {
    const sliderPanel = document.querySelector(".slider-panel-Reinforcement");
    if (sliderPanel) {
      sliderPanel.style.display = "none";
    }
  };
  const toggleTopForm = () => {
    setShowTopDetails(!showTopDetails);
  };

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await fetchItemData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call the async function
    fetchDataAsync();
  }, [partLot_LotNum]);

  const fetchItemData = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/testUploading/${partLot_LotNum}?company=${company}`,
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setItemData({ ...data });
      console.log(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [botReinforcement, setBotReinforcement] = useState({
    LLong: "",
    ECross: "",
    DCross: "",
  });
  const [topReinforcement, setTopReinforcement] = useState({
    LLong: "",
    ECross: "",
    DCross: "",
  });

  const handleBotReinforcementChange = (e) => {
    const { name, value } = e.target;
    setBotReinforcement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleTopReinforcementChange = (e) => {
    const { name, value } = e.target;
    setTopReinforcement((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <>
      <div className="slider-panel-Reinforcement">
        <div className="d-flex justify-content-between align-items-center slidePanel-Title">
          <h5 className="MoldIdSlide">Reinforcement</h5>
          <button className="close-btn" onClick={closeSliderPanel}>
            <FaTimes size={20} style={{ cursor: "pointer", color: "black" }} />{" "}
          </button>
        </div>

        <div className="content mt-4 border p-1 ">
          {/* BOT Reinforcement Section */}
          <div className="Form-Panel m-1 px-2 py-2">
            <div className="title-border-bottom">
              <button className="toggle-btn my-3 mx-5 d-flex" onClick={toggleBotForm}>
                <FontAwesomeIcon className="mx-2" icon={faArrowDown} />
                <h6 className="mb-2 ">BOT. REINFORCEMENT (MM)</h6>
              </button>
            </div>
          </div>
          {showBotDetails && (
            <>
              <div className="d-flex justify-content-between bg-re p-5 m-1">
                <div className="form-group col-3">
                  <label htmlFor="LLong">L Long</label>
                  <input
                    type="text"
                    id="LLong"
                    name="LLong"
                    className="form-control"
                    value={botReinforcement.LLong}
                    onChange={handleBotReinforcementChange}
                  />
                </div>

                <div className="form-group col-3">
                  <label htmlFor="ECross">E CROSS</label>
                  <input
                    type="text"
                    id="ECross"
                    name="ECross"
                    className="form-control"
                    value={botReinforcement.ECross}
                    onChange={handleBotReinforcementChange}
                  />
                </div>

                <div className="form-group col-3">
                  <label htmlFor="DCross">D CROSS</label>
                  <input
                    type="text"
                    id="DCross"
                    name="DCross"
                    className="form-control"
                    value={botReinforcement.DCross}
                    onChange={handleBotReinforcementChange}
                  />
                </div>
              </div>
            </>
          )}
          {/* TOP Reinforcement Section */}
          <div className="Form-Panel m-1 px-2 py-2">
            <div className="title-border-bottom">
              <button className="toggle-btn my-3 mx-5 d-flex" onClick={toggleTopForm}>
                <FontAwesomeIcon className="mx-2" icon={faArrowDown} />
                <h6>TOP. REINFORCEMENT (MM)</h6>
              </button>
            </div>
          </div>
          {showTopDetails && (
            <>
              <div className="top-reinforcement ">
                <div className="d-flex justify-content-between bg-re p-5 m-1">
                  <div className="form-group col-3">
                    <label htmlFor="LLong">L Long</label>
                    <input
                      type="text"
                      id="LLong"
                      name="LLong"
                      className="form-control"
                      value={topReinforcement.LLong}
                      onChange={handleTopReinforcementChange}
                    />
                  </div>

                  <div className="form-group col-3">
                    <label htmlFor="ECross">E CROSS</label>
                    <input
                      type="text"
                      id="ECross"
                      name="ECross"
                      className="form-control"
                      value={topReinforcement.ECross}
                      onChange={handleTopReinforcementChange}
                    />
                  </div>

                  <div className="form-group col-3">
                    <label htmlFor="DCross">D CROSS</label>
                    <input
                      type="text"
                      id="DCross"
                      name="DCross"
                      className="form-control"
                      value={topReinforcement.DCross}
                      onChange={handleTopReinforcementChange}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <button class="submit-btn ro d-block m-2 mt-3 rounded" onClick={UpdateElementData}>
          Save{" "}
        </button>
      </div>
      <button
        onClick={handleBack}
        style={{ background: "none", border: "none", cursor: "pointer" }}
      >
        <FontAwesomeIcon icon={faArrowLeft} size="lg" />
      </button>
      <div className="body-container rounded border p-1 ">
        <div className="title-bg rounded d-flex justify-content-between aligin-items-center">
          <h3>Smart Planner AAC</h3>
          <button class="submit-btn ro d-block m-2 rounded " onClick={fetchElment}>
            Generate Reinforcement
          </button>
        </div>
        <ReinforcementBody
          key={key}
          itemData={itemData}
          showBotDetails={showBotDetails}
          showTopDetails={showTopDetails}
          toggleBotForm={toggleBotForm}
          toggleTopForm={toggleTopForm}
          fetchElment={fetchElment}
          handleBack={handleBack}
        />
      </div>
    </>
  );
}

export default Reinforcement;
